import React, { useEffect, memo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    campaignGetAreaManagerDealersRequest,
    campaignGetPerformanceMetricsByDealerDropDownRequest,
    campaignGetPerformanceMetricsByDealerRequest,
    campaignGetWareAndTireSummaryRequest,
} from "../../../../_redux/_actions";
import { UiSlider } from "../../../_uiComponents/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../_uiComponents/common/UiSliderArrows";
import UiVeticalChartElement from "../../../_uiComponents/common/UiVeticalChartElement";
import UiAbuDhabiVeticalChartElement from "../../../_uiComponents/common/UiAbuDhabiVeticalChartElement";
import UiTopNavSelect from "../../../_uiComponents/common/custom/header/UiTopNavSelect";
import UiDealerSelect from "../../../_uiComponents/common/UiDealerSelect";
import ZeroState from "../../../../styles/img/no-data-zero-state.png";
import {
    userTypes,
    participantJobRoleIds,
    participantTypeIds,
} from "../../../../_redux/_constants";

const QuarterPerformanceChart = memo((props) => {
    const actionDispatch = useDispatch();

    const { areaManagerDealers, performanceMetrics, auth } = useSelector(
        (state) => {
            return {
                areaManagerDealers: state.campaign,
                performanceMetrics: state.campaign.performanceMetricsByDealer,
                auth: state.auth,
            };
        },
    );

    const [dealer, setDealer] = useState(null);

    const filterSlider = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipe: "false",
        swipeToSlide: "false",
        touchMove: "false",
        draggable: "false",
        centerPadding: 30,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    const sortingOrder = performanceMetrics.sort(
        (a, b) => b.salesQuarter - a.salesQuarter,
    );

    useEffect(() => {
        if (
            auth?.userProfileDetails.jobRoleId !==
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
            auth?.userProfileDetails.roleId ==
                participantTypeIds.PARTICIPANT &&
            auth?.userProfileDetails?.dealerships &&
            auth?.userProfileDetails?.dealerships?.length !== 0
        ) {
            actionDispatch(
                campaignGetPerformanceMetricsByDealerRequest({
                    dealerCode:
                        auth?.userProfileDetails?.dealerships[0]?.dealerCode,
                }),
            );
        }
    }, [auth?.userProfileDetails?.dealerships]);

    useEffect(() => {
        if(auth?.userProfileDetails.jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER 
            && dealer === null && areaManagerDealers?.areaManagerDealers.length !== 0){
                actionDispatch(
                    campaignGetPerformanceMetricsByDealerRequest({
                        dealerCode:
                        areaManagerDealers?.areaManagerDealers[0]?.code,
                    }),
                );
        }
    } , [areaManagerDealers?.areaManagerDealers])


    const ChangeOption = (item) => {
        setDealer(item);
        actionDispatch(campaignGetPerformanceMetricsByDealerDropDownRequest({dealerCode:item?.value}));
    };


    return (
        <>
            {auth?.userProfileDetails.jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                auth?.userProfileDetails.roleId ==
                    participantTypeIds.PARTICIPANT && (
                    <div className="sb-performance-dealer-select">
                        <UiDealerSelect
                            dealerOptions={areaManagerDealers?.areaManagerDealers.map(
                                (dealerships) => {
                                    return {
                                        value: dealerships.code,
                                        label: dealerships.name,
                                    };
                                },
                            )}
                            onChange={(item)=>{ChangeOption(item)}}
                            dealerships={areaManagerDealers?.areaManagerDealers}
                            isDashBoard={false}
                            selectDealer={true}
                        />
                    </div>
                )}
            {sortingOrder.length > 0 ? (
                <UiSlider UiSliderSettings={filterSlider}>
                    {sortingOrder?.map((items, indexPage) => {
                        return (
                            <div className="sb-abu-dhabi-measure">
                                <div className="sb-wear-and-tear-wr">
                                    <h3>{`Q${items?.salesQuarter} Performance`}</h3>
                                    <div className="sb-top-target-wr">
                                        <h5>
                                            TARGET: £
                                            {items?.salesTarget?.toFixed(2)}
                                        </h5>
                                        <h5>
                                            ACTUAL: £
                                            {items?.salesActual?.toFixed(2)}
                                        </h5>
                                        <h5>
                                            {sortingOrder.length ===
                                            items?.salesQuarter
                                                ? "PROVISIONAL POINTS:"
                                                : "LEAGUE POINTS"}{" "}
                                            <span className="sb-slider-league-points">
                                                {items?.points}
                                            </span>{" "}
                                        </h5>
                                    </div>
                                </div>
                                <div className="sb-measure ">
                                    <div className="sb-measure__list ">
                                        <UiAbuDhabiVeticalChartElement
                                            actualScore={
                                                items?.salesTargetAchievementPercentage
                                            }
                                        />
                                    </div>
                                    <div className="sb-target-chart">
                                        <div
                                            className="sb-target-chart__brake-discs"
                                            style={{
                                                height: `${
                                                    (items?.brakeDiscsSalesPercentage *
                                                        100) /
                                                    138
                                                }%`,
                                            }}
                                        >
                                            {items?.brakeDiscsSales && (
                                                <>
                                                    {" "}
                                                    <label>
                                                        £{" "}
                                                        {items?.brakeDiscsSales.toFixed(
                                                            2,
                                                        )}
                                                    </label>{" "}
                                                </>
                                            )}
                                        </div>
                                        <div
                                            className="sb-target-chart__wiper-blade"
                                            style={{
                                                height: `${
                                                    (items?.wiperBladeSalesPercentage *
                                                        100) /
                                                    138
                                                }%`,
                                            }}
                                        >
                                            {items?.wiperBladeSales && (
                                                <>
                                                    <label>
                                                        £{" "}
                                                        {items?.wiperBladeSales.toFixed(
                                                            2,
                                                        )}
                                                    </label>
                                                </>
                                            )}
                                        </div>
                                        <div
                                            className="sb-target-chart__brake-pads"
                                            style={{
                                                height: `${
                                                    (items?.brakePadsSalesPercentage *
                                                        100) /
                                                    138
                                                }%`,
                                            }}
                                        >
                                            {items?.brakePadsSales && (
                                                <>
                                                    {" "}
                                                    <label>
                                                        £{" "}
                                                        {items?.brakePadsSales.toFixed(
                                                            2,
                                                        )}
                                                    </label>
                                                </>
                                            )}
                                        </div>
                                        <div
                                            className="sb-target-chart__battery"
                                            style={{
                                                height: `${
                                                    (items?.batterySalesPercentage *
                                                        100) /
                                                    138
                                                }%`,
                                            }}
                                        >
                                            {items?.batterySales && (
                                                <>
                                                    <label>
                                                        £{" "}
                                                        {items?.batterySales.toFixed(
                                                            2,
                                                        )}
                                                    </label>{" "}
                                                </>
                                            )}
                                        </div>

                                        {props?.salesQuarter !== 3 &&
                                        items?.wearAndTearMyPerformanceData
                                            ?.latestTotalSalePercentage >=
                                            100 ? (
                                            <div className="sb-target-chart__latest-total-wr">
                                                <span className="sb-target-chart__winner">
                                                    WINNER
                                                </span>
                                            </div>
                                        ) : (
                                            <div className="sb-target-chart__below-winner-wr">
                                                <span className="sb-target-chart__below-winner"></span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </UiSlider>
            ) : (
                <div className="sb-performance-zero-state">
                    <img src={ZeroState} />
                    <h4>Performance data not available</h4>
                </div>
            )}

            {/* <div className='sb-target-chart-label' >
                <h4>Targeted Products</h4>
                <div className='sb-batter-label-top-column'>
                    <div className='sb-battery-label'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Battery </label>
                        </div>
                    </div>
                    <div className='sb-wiper-blade'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Wiper Blades </label>
                        </div>
                    </div>
                </div>
                <div className='sb-batter-label-bottom-column'>
                    <div className='sb-brake-pads'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Brake Pads</label>
                        </div>
                    </div>
                    <div className='sb-brake-discs'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Brake Discs</label>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div className='sb-last-update'>
                Updated: {items?.lastUpdatedDate}
            </div> */}
        </>
    );
});
export default QuarterPerformanceChart;
